export const GET_LICENCE_SCOPES_ENDPOINT = 'admin/licence_scopes/'
export const POST_LICENCE_SCOPE_ENDPOINT = 'admin/licence_scopes/'
export const GET_SUB_SCOPES_ENDPOINT = 'admin/sub_scopes'
export const ROLE_ASSETS_ENDPOINT = 'admin/assets'
